import React, { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Briefcase, Image, MessageSquare, FileText, Calendar } from "lucide-react";

const AdminOverview = () => {
  const [stats, setStats] = useState({
    services: 0,
    gallery: 0,
    testimonials: 0,
    blogPosts: 0,
    bookings: 0,
  });

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const token = localStorage.getItem("adminToken");
      const headers = { Authorization: `Bearer ${token}` };

      const [services, gallery, testimonials, blog, bookings] = await Promise.all([
        axios.get(`${API}/services`),
        axios.get(`${API}/gallery`),
        axios.get(`${API}/testimonials`),
        axios.get(`${API}/blog`),
        axios.get(`${API}/bookings`, { headers }),
      ]);

      setStats({
        services: services.data.length,
        gallery: gallery.data.length,
        testimonials: testimonials.data.length,
        blogPosts: blog.data.length,
        bookings: bookings.data.length,
      });
    } catch (error) {
      console.error("Error fetching stats:", error);
    }
  };

  const statCards = [
    { title: "Services", value: stats.services, icon: Briefcase, color: "text-blue-600" },
    { title: "Gallery Images", value: stats.gallery, icon: Image, color: "text-green-600" },
    { title: "Testimonials", value: stats.testimonials, icon: MessageSquare, color: "text-purple-600" },
    { title: "Blog Posts", value: stats.blogPosts, icon: FileText, color: "text-orange-600" },
    { title: "Bookings", value: stats.bookings, icon: Calendar, color: "text-red-600" },
  ];

  return (
    <div data-testid="admin-overview">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Dashboard Overview</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {statCards.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <Card key={index} data-testid={`stat-card-${index}`}>
              <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-sm font-medium text-gray-600">
                  {stat.title}
                </CardTitle>
                <Icon className={stat.color} size={24} />
              </CardHeader>
              <CardContent>
                <div className="text-3xl font-bold">{stat.value}</div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default AdminOverview;
